import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { login, authSSO } from "../../Stores/Action/AuthAction";
import { modena_login_bg, microsoft } from '../../Images';
import Swal from 'sweetalert2';
import MicrosoftLogin from 'react-microsoft-login';
import { NavLink } from 'react-router-dom';

const LoginPage = () => {
  const client_id = process.env.REACT_APP_MS_CLIENT_ID;
  const tenant_url = process.env.REACT_APP_MS_AZURE_AD_TENANT;
  const redirect_uri = process.env.REACT_APP_MS_CLIENT_URL;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pswState, setPswState] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onPasswordStateChange = () => {
    setPswState(!pswState);
  };

  const microsoftAuthHandler = (err, data) => {

    if (err) {
      console.log('Error', err);
      return;
    }
    
    dispatch(authSSO(navigate, { access_token: data.accessToken }, ({ response }) => {
      if (response.data && response.data.message) {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: response.data.message,
          timer: 1500,
        })
      }

    }));
  }

  const onSubmit = (data) => {
    dispatch(
      login(navigate, data, ({ response }) => {
        if (response.data && response.data.message) {
          setErrorMessage(response.data.message);
        }
      })
    );

    <Navigate to="/home" replace={true} />;
  };

  return (
    <div className='login-container' style={{ height: '100vh' }}>
      <div className='bg-login d-flex justify-content-center align-items-center' style={{ backgroundImage: `url(${modena_login_bg})`, backgroundSize: 'cover', backgroundPosition: 'center center' }}></div>
      <div className='login-form' style={{}}>
        <div className='d-flex' style={{ height: '100%', flexDirection: 'column', justifyContent: "center" }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='row' style={{ width: '100%' }}>
              <div className='col-1'></div>
              <div className='col-10'>
                <div className='form-group mb-3'>
                  <h1 style={{ color: '#777' }}>Login</h1>
                  <h4 style={{ color: '#777', fontSize: 18, fontWeight: 400, marginBottom: 20 }}>Digital Assets Bank</h4>
                </div>
                <div className='form-group'>
                  <label>Email or User Name</label>
                  <div style={{ border: 'solid 1px #ccc', borderRadius: 4 }}>
                    <input {...register('email', { required: { value: true, message: 'Email is required' } })} className='inputLogin' />
                  </div>
                  {errors.email && <span className='text-danger'>{errors.email.message}</span>}
                </div>
                <div className='form-group'>
                  <label>Password</label>
                  <div style={{ border: 'solid 1px #ccc', borderRadius: 4, display: 'flex' }}>
                    <input className='inputLogin' type={pswState ? "text" : "password"} {...register('password', { required: { value: true, message: 'Password is required' } })} />
                    <a onClick={onPasswordStateChange} className='btn btn-outline'><i style={{ color: "#000" }} className={pswState ? 'fa fa-eye' : 'fa fa-eye-slash'} /></a>
                  </div>
                  {errors.password && <span className='text-danger'>{errors.password.message}</span>}
                </div>
                <div className='form-group'>
                  {errorMessage && <span className='text-danger'>{errorMessage}</span>}
                </div>
                <div className='form-group'>
                  <div style={{ marginTop: 40 }}>
                    <button type='submit' className='btn btn-block btn-dark btn-lg' style={{width: `100%`}}><i className='fa fa-lock' /> Login</button>
                  </div>
                </div>
                <div className='form-group'>
                    <MicrosoftLogin clientId={client_id} authCallback={microsoftAuthHandler}
                      tenantUrl={tenant_url} redirectUri={redirect_uri}>
                      <div style={{
                        marginTop: 20,
                        height: 41,
                        border: 'solid 1px #ccc',
                        borderRadius: 5, display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                      }}>
                        <img src={microsoft} style={{ width: 20, height: 20, marginRight: 10 }} alt='' />Microsoft Login
                      </div>
                    </MicrosoftLogin>
                  </div>
                  <div className='form-group'>
                    <div style={{ marginTop: 40 }}>
                      <span>Don't have an account? &nbsp;
                        <NavLink to={'/register'} className='href-bold-green'>Sign Up</NavLink>
                      </span>
                    </div>
                  </div>
                </div>
              <div className='col-1'></div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
